import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../auth/services/auth.service';

export const ssoCallbackGuard: CanActivateFn = async route => {
  const platformId = inject(PLATFORM_ID);
  const auth = inject(AuthService);
  if (isPlatformServer(platformId)) return true;
  await auth.init();
  auth.clerk.handleRedirectCallback({ redirectUrl: route.queryParams.redirectUri || '/a/galleries' });
  return true;
};
